document.addEventListener("DOMContentLoaded", function () {
    const contents = document.querySelectorAll('.collasible-content-section');
    const titles = document.querySelectorAll('.collapsible-content__heading');
    
    // Create the sidebar element
    const sidebar_element = document.createElement('div');
    sidebar_element.classList.add('sidebar-element');
    const scroll_bar = document.createElement('div');
    scroll_bar.classList.add('scrollbar-element');

    // Add titles and IDs to the sidebar and content sections
    titles.forEach((item, index) => {
        const title = document.createElement('p');
        title.textContent = item.textContent;
        title.classList.add('faq-sidebar-item');
        title.id = `sidebar_${index}`;
        scroll_bar.appendChild(title);

        contents[index].id = `content_${index}`;
    });

    sidebar_element.appendChild(scroll_bar);

    // Add a clone of the sidebar to each collapsible wrapper
    const collapsibleWrappers = document.querySelectorAll('.collapsible-content__wrapper');
    collapsibleWrappers.forEach(wrapper => {
        const sidebarClone = sidebar_element.cloneNode(true); // Clone the sidebar
        wrapper.appendChild(sidebarClone);
    });
});


document.addEventListener("DOMContentLoaded", function(){

    const contents = document.querySelectorAll('.collasible-content-section');
    contents.forEach((item, index)=>{
        if(index == 0){
            item.classList.remove('hidden-ele')
        }
        else{
            item.classList.add('hidden-ele')
        }
    })

    window.addEventListener('resize', create_sidebar);

    create_sidebar()

    const sidebar_items = document.querySelectorAll('.faq-sidebar-item');

    sidebar_items.forEach((item, index)=>{
        item.addEventListener('click', function(){
            contents.forEach((it, ind)=>{
                if(item.id.split('_')[1] == `${it.id.split('_')[1]}`){
                    it.classList.remove('hidden-ele')
                }
                else{
                    it.classList.add('hidden-ele')
                }
            })
        })
    })

    function create_sidebar(){
        const bread_height = document.querySelector('.breadthumbs').offsetHeight;
        const banner_height = document.querySelector('.main-rich-text-section').offsetHeight;
        const sidebar_element = document.querySelector('.sidebar-element');
    
        sidebar_element.style.top = `${bread_height + banner_height}px`;

        if(window.innerWidth >= 1200){
            const left = (window.innerWidth - 1100) / 2;
            sidebar_element.style.left = `${left}px`;
        }
        else{

        }
    }
})